import { Link } from 'react-router-dom';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { useCart } from '../../context/CartContext';

export default function CartPage() {
  const { cart, removeFromCart, updateQuantity, getCartTotal } = useCart();

  const shippingCost = 0;
  const total = getCartTotal() + shippingCost;

  if (cart.length === 0) {
    return (
      <div className="min-h-screen bg-gray-50 font-poppins">
        <Header />
        <div className="container mx-auto px-4 py-16">
          <div className="bg-white rounded-lg shadow-sm p-12 text-center max-w-md mx-auto">
            <i className="ri-shopping-cart-line text-6xl text-gray-300 mb-4"></i>
            <h2 className="text-2xl font-bold text-gray-800 mb-3">Sepetiniz Boş</h2>
            <p className="text-gray-600 mb-6">
              Henüz sepetinize ürün eklemediniz. Alışverişe başlamak için ürünlerimize göz atın.
            </p>
            <Link
              to="/kategori"
              className="inline-block bg-gold-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gold-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Alışverişe Başla
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Sepetim</h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
              {cart.map((item) => (
                <div key={item.id} className="flex gap-4 p-4 border-b border-gray-200 last:border-b-0">
                  <div className="w-24 h-24 flex-shrink-0 bg-gray-50 rounded-lg overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>

                  <div className="flex-1 min-w-0">
                    <Link
                      to={`/urun/${item.id}`}
                      className="font-medium text-gray-800 hover:text-gold-600 transition-colors line-clamp-2 cursor-pointer"
                    >
                      {item.name}
                    </Link>
                    <div className="flex items-center gap-3 mt-2 text-sm text-gray-600">
                      <span>{item.gram}gr</span>
                      <span>•</span>
                      <span>{item.karat} Ayar</span>
                    </div>

                    <div className="flex items-center justify-between mt-3">
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity - 1)}
                          className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                        >
                          <i className="ri-subtract-line text-sm"></i>
                        </button>
                        <span className="w-12 text-center font-medium">{item.quantity}</span>
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity + 1)}
                          disabled={item.quantity >= item.stock}
                          className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
                        >
                          <i className="ri-add-line text-sm"></i>
                        </button>
                      </div>

                      <div className="text-right">
                        <div className="font-semibold text-gold-600">
                          {(item.price * item.quantity).toLocaleString('tr-TR')} ₺
                        </div>
                        <div className="text-sm text-gray-500">
                          {item.price.toLocaleString('tr-TR')} ₺ / adet
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    onClick={() => removeFromCart(item.id)}
                    className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-delete-bin-line text-lg"></i>
                  </button>
                </div>
              ))}
            </div>

            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mt-4">
              <div className="flex items-start gap-3">
                <i className="ri-information-line text-amber-600 text-xl mt-0.5"></i>
                <p className="text-sm text-amber-800">
                  <strong>Önemli Not:</strong> Altın fiyatları anlık olarak değişebilmektedir. 
                  Ödeme sırasında güncel fiyatlar üzerinden işlem yapılacaktır.
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-sm p-6 sticky top-24">
              <h2 className="text-lg font-semibold text-gray-800 mb-4">Sipariş Özeti</h2>

              <div className="space-y-3 mb-4 pb-4 border-b border-gray-200">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Ara Toplam</span>
                  <span className="font-medium">{getCartTotal().toLocaleString('tr-TR')} ₺</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Kargo</span>
                  <span className="font-medium text-green-600">Ücretsiz</span>
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  İndirim Kuponu
                </label>
                <div className="flex gap-2">
                  <input
                    type="text"
                    placeholder="Kupon kodunuz"
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gold-500"
                  />
                  <button className="px-4 py-2 bg-gray-800 text-white rounded-lg text-sm hover:bg-gray-900 transition-colors cursor-pointer whitespace-nowrap">
                    Uygula
                  </button>
                </div>
              </div>

              <div className="flex justify-between text-lg font-bold text-gray-800 mb-6 pt-4 border-t border-gray-200">
                <span>Toplam</span>
                <span className="text-gold-600">{total.toLocaleString('tr-TR')} ₺</span>
              </div>

              <Link
                to="/odeme"
                className="block w-full bg-gold-600 text-white text-center py-4 rounded-lg font-semibold hover:bg-gold-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Ödemeye Geç
              </Link>

              <Link
                to="/kategori"
                className="block w-full text-center text-gold-600 py-3 mt-3 hover:text-gold-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Alışverişe Devam Et
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
